import { render, staticRenderFns } from "./contract-history-report.vue?vue&type=template&id=dbbc12b8&scoped=true&"
import script from "./contract-history-report.vue?vue&type=script&lang=js&"
export * from "./contract-history-report.vue?vue&type=script&lang=js&"
import style0 from "./contract-history-report.vue?vue&type=style&index=0&id=dbbc12b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbc12b8",
  null
  
)

export default component.exports